import React from 'react';
import PropTypes from 'prop-types';

const BankruptcyPartiesResultTable = ({ data }) => (
  <table className="ir-search-table-results sticky-enabled sticky-table">
    <thead className="tableHeader-processed">
      <tr>
        <th>Party Name</th>
        <th>Role</th>
        <th>Court</th>
        <th>Case No</th>
        <th>Chapter</th>
        <th>Date Filed</th>
        <th>Date Closed</th>
      </tr>
    </thead>
    <tbody>
      {data.map((row, idx) => (
        <tr key={idx}>
          <td>{row.party_name}</td>
          <td>{row.party_role}</td>
          <td>{row.court_code}</td>
          <td className="ir-search-no-wrap">
            <a
              href={`/rpc/legacy/case-menu-redirect/${row.court_code}/${row.case_no}`}
              target="_blank"
            >
              {row.case_no}
            </a>
          </td>
          <td>{row.chapter}</td>
          <td>{row.date_filed}</td>
          <td>{row.date_closed}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

BankruptcyPartiesResultTable.propTypes = {
  data: PropTypes.array.isRequired,
};

export default BankruptcyPartiesResultTable;



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/BankruptcyPartiesResultTable.jsx